import { Document, Page, pdfjs } from 'react-pdf'

import { useState } from 'react'

import { Loading } from 'apps/builder/components/shared/animations'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const onboardingPDFendpoint = `/onboard/stream_pdf`

const LoadingPDF = () => (
  <>
    <Loading />
    <h3 className="t-center">Creating your PDF...</h3>
  </>
)

export const SubmissionPDF = ({
  submissionId,
  onLoad = () => {},
  pdfPath = null,
  inline,
}) => {
  const pdfUrl = pdfPath ? pdfPath : `${onboardingPDFendpoint}/${submissionId}`
  const [complete, setComplete] = useState(false)
  const [attempts, updateAttempts] = useState(0)
  const [numPages, setNumPages] = useState(null)
  const [inlineView, toggleInlineView] = useState(inline)
  const [pageNumber, setPageNumber] = useState(1)

  // This is somethign of a "magic" number, but it gives us a better
  // base size than the defaults. It may make sense to make this more
  // dynamic in the future, which we could do by querying the viewport
  const PDFHeight = 1000

  const setSubmissionViewed = () => {
    onLoad()
  }

  const changePage = offset => {
    setPageNumber(prevPageNumber => prevPageNumber + offset)
  }

  const previousPage = () => {
    changePage(-1)
  }

  const nextPage = () => {
    changePage(1)
  }
  const firstPage = pageNumber === 1
  const lastPage = pageNumber === numPages

  const PDFNAvigation = () => {
    return (
      <div className="pagination--wrap">
        <button
          className="foundry--button button--outlined button--condensed"
          onClick={() => toggleInlineView(!inlineView)}
        >
          <span className="button--label">
            {inlineView ? 'Paginated View' : 'View All'}
          </span>
        </button>
        
        <nav
          className={`foundry--pagination submission--pagination ${
            inlineView ? 'view--inline' : 'view--paginated'
          }`}
        >
          <div className={`pagination--page ${firstPage ? 'disabled' : ''}`}>
            <i
              onClick={firstPage ? () => {} : previousPage}
              className="foundry-icon icon--angle-left"
            ></i>
          </div>
          {Array.from(new Array(numPages), (el, index) => (
            <div
              onClick={() => setPageNumber(index + 1)}
              className={`pagination--page ${
                index + 1 === pageNumber ? 'active' : ''
              }`}
            >
              {index + 1}
            </div>
          ))}
          <div className={`pagination--page ${lastPage ? 'disabled' : ''}`}>
            <i
              onClick={lastPage ? () => {} : nextPage}
              className="foundry-icon icon--angle-right"
            ></i>
          </div>
        </nav>
      </div>
    )
  }

  const ErrorMessage = () => {
    return (
      <div className="foundry--modal modal--medium foundry--card t-center">
        <h3 className="modal--title">Error Loading PDF</h3>

        <p>
          Oops! Looks like something went wrong loading the PDF. Please try
          again.
        </p>

        <div className="modal--footer">
          <button
            type="button"
            className="foundry--button button--active modal--confirm-button"
            onClick={() => {
              updateAttempts(attempts + 1)
              setComplete(false)
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    )
  }

  return (
    <section className="submission--pdf">
      <Document
        key={`${submissionId}-attempt-${attempts}`}
        file={pdfUrl}
        error={ErrorMessage}
        loading={LoadingPDF}
        className={complete ? 'pdf--complete' : 'pdf--loading'}
        renderAnnotationLayer={false}
        onLoadSuccess={({ numPages }) => {
          setNumPages(numPages)
          setPageNumber(1)
          setSubmissionViewed()
          setComplete(true)
        }}
        onLoadError={setSubmissionViewed}
      >
        {inlineView ? (
          [...Array(numPages).keys()].map(pageNumber => (
            <Page pageNumber={pageNumber + 1} height={PDFHeight} />
          ))
        ) : (
          <Page pageNumber={pageNumber} height={PDFHeight} />
        )}
      </Document>
      {numPages > 1 && <PDFNAvigation />}
    </section>
  )
}
